<script lang="ts" setup>
import OrderSection from '../OrderSection.vue';
import FleetConfiguration from './FleetConfiguration.vue';

defineProps<{ nodes: Array<string> }>();

const emit = defineEmits<{ (e: 'setNodes', value: Array<string>) }>();
const handleSetNodes = (nodes: Array<string>) => {
  emit('setNodes', nodes);
};
</script>

<template>
  <OrderSection
    pre-title="Step 6"
    title="Nodes configuration"
    section-key="nodes"
    :is-done="nodes.length > 0"
    v-playwright="'nodes-create-fleet'"
  >
    <p class="tw-mb-4">
      You are able to add multiple nodes at once to your order. They will all be deployed to the
      selected project and installed with the same OS, the same keys or password and the same user
      data script.
    </p>

    <FleetConfiguration @setNodes="handleSetNodes" />
  </OrderSection>
</template>
